import React, { useEffect } from 'react'
import img from '../../assets/hire2.png'

const HirewithHH = () => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (
        <div className='bigscreen p-16'>

            {/* <div className='bg-white rounded-[32px] shadow p-10'> */}

            <div className='flex justify-between items-center gap-10'>
                <div className='w-full'>
                    <div className='text-4xl font-bold'>
                        Hire with <span className='text-[var(--primary)]'>HH</span>
                    </div>
                    <div className='text- medium text-sm max-w-[560px] mt-10'>
                        At Hunt High, we go beyond traditional recruitment—we are strategic partners in building your most valuable asset: people. By bridging high-performing individuals with forward-thinking companies, we create opportunities where collaboration, innovation, and continuous learning thrive.
                    </div>
                    <div className='text-medium text-sm max-w-[560px] mt-2'>
                        Our unique Consultancy-As-A-Service (CONaaS) model ensures unmatched agility and flexibility, scaling solutions to meet your specific needs. Whether you’re hiring for a critical role today or planning a long-term strategy, we align behavioral fit, emotional intelligence, and cultural synergy to deliver outcomes that go beyond expectations.
                    </div>
                </div>

                <div className='w-full'>
                    <img src={img} className='h-full w-full object-contain' />
                </div>
            </div>


            <div className='font-semibold text-[28px] text-center mt-24'>
                Here is What Makes the Difference
                {/* <span className='text-[#EE7828B5] font-bold'>Makes the Difference</span> */}
            </div>

            <div className='flex flex-wrap gap-10 justify-center mt-10'>
                {coreValues && coreValues.map((item, i) => (

                    <div key={i} className="p-6 rounded-[20px] w-[calc(50%-32px)] shadow-md bg-white max-w-[480px]">

                        <div className='bg-[var(--primary)] rounded-full flex items-center justify-center text-2xl font-bold text-white h-12 w-12'>
                            {i + 1}
                        </div>

                        <h3 className="font-semibold text-xl mt-8">{item.head}</h3>
                        <p className="text-gray-600 font-light text-sm mt-2">{item.body}</p>
                    </div>

                ))}
            </div>

            <div className='mt-40 mb-20 font-semibold text-center mx-auto'>
                <div className='font-bold text-lg'>Hunt High</div> 
                <div className='text-sm italic'>defining what it means to hire, grow, and succeed.</div>
                <button className='button text-sm mt-6'>Partner With Us to Build Your Team</button>
            </div>

            {/* </div> */}
        </div>
    )
}

export default HirewithHH

const coreValues = [
    {
        head: "People at the Core",
        body: "We believe people are the most valuable asset, and our efforts center on nurturing and connecting the right talent with the right opportunities."
    },
    {
        head: "Dynamic Talent Ecosystems",
        body: "It’s not just recruitment—it’s about building ecosystems where continuous learning, collaboration, and growth thrive."
    },
    {
        head: "Tailored Precision",
        body: "Whether it's individuals or businesses, we craft bespoke solutions tailored to unique needs, ensuring the perfect match."
    },
    {
        head: "Impact in 90-180 Days",
        body: "Results-driven solutions designed to create transformative growth within a measurable timeframe."
    },
    {
        head: "Human-Centric Approach",
        body: "We assess more than skills—we focus on emotional intelligence and behavioral alignment to create partnerships that truly work."
    }
];
